import {
    MAPPINGBANKFORPARTNER_SUCCESS,
    MAPPINGBANKFORPARTNER_FAILED,
    RESET_MAPPINGBANKFORPARTNER,
    LOADING_MAPPINGBANKFORPARTNER,
    NETWORK_ERROR_MAPPINGBANKFORPARTNER,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_MAPPINGBANKFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case MAPPINGBANKFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case MAPPINGBANKFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_MAPPINGBANKFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_MAPPINGBANKFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};
